import type { Survey, SurveyDTO, SurveyStatsResponseDTO, GetSurveyStatsResponse, ChainSurvey } from './types'

export function surveyDtoToSurvey(survey: SurveyDTO): Survey {
	return {
		id: survey.id,
		surveyContract: survey.surveyContract,
		question: survey.question,
		answers: survey.answers.map(answer => ({
			id: answer.id,
			totalTokens: BigInt(answer.totalTokens),
			totalVotes: BigInt(answer.totalVotes)
		})),
		startDate: new Date(survey.startDate),
		endDate: new Date(survey.endDate),
		metadataURL: survey.metadataURL || undefined,
		totalVotes: survey.totalVotes,
		totalTokensUsed: survey.totalTokensUsed,
		votingCap: survey.votingCap,
		status: survey.status
	}
}

export function chainSurveyToSurvey(survey: ChainSurvey): Survey {
	const endDate = new Date(Number(survey.endDate) * 1000)

	return {
		// This ID is coming from the Survey Factory. We don't have access to it here and we're not using it anyways, hence the random value.
		id: Math.floor(Math.random() * 1000),
		surveyContract: survey.address,
		question: survey.question,
		answers: survey.answers.map(answer => ({
			id: answer.id,
			totalTokens: answer.totalTokens,
			totalVotes: answer.totalVotes
		})),
		startDate: new Date(Number(survey.startDate) * 1000),
		endDate,
		metadataURL: survey.metadataURL || undefined,
		totalVotes: survey.totalVotes.toString(),
		totalTokensUsed: survey.totalTokensUsed.toString(),
		votingCap: survey.votingCap.toString(),
		status: survey.isOpen ? 'ongoing' : endDate.getTime() > Date.now() ? 'upcoming' : 'ended'
	}
}

export function dtoToSurveyStats(surveyStats: SurveyStatsResponseDTO): GetSurveyStatsResponse {
	return {
		count: surveyStats.count,
		lastUpdated: new Date(surveyStats.lastUpdated)
	}
}
